import React, { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'design-system/Button';
import EmptyComponent from 'design-system/EmptyComponent';
import SuccessView from 'design-system/SuccessView';
import useDisableAndroidBackButton from 'hooks/useDisableAndroidBackButton';
import StatusBar from 'design-system/StatusBar';
import { ButtonGroup } from 'design-system/ButtonGroup';
const strings = {
    success: 'Success',
    continue: 'Continue',
};
export const SuccessScreen = React.memo(({ route, navigation }) => {
    const { onContinue, BtnPrefixComponent, buttonText, dontLockButton, onSecondaryButtonPress, onSkip, secondaryButtonLeftIcon, secondaryButtonText, skipButtonText, title, ...successViewProps } = route.params;
    useLayoutEffect(() => {
        navigation.setOptions({
            gestureEnabled: false,
            headerLeft: EmptyComponent,
        });
    }, []);
    const hasPressedContinue = React.useRef(false);
    const handlePress = React.useCallback(() => {
        if (dontLockButton) {
            return onContinue();
        }
        if (!hasPressedContinue.current) {
            hasPressedContinue.current = true;
            return onContinue();
        }
        return true;
    }, [dontLockButton, onContinue]);
    useDisableAndroidBackButton(handlePress);
    return (<View style={styles.container}>
        <StatusBar barStyle="dark-content" animated/>
        <SuccessView {...successViewProps} title={title || strings.success}>
          <ButtonGroup type="floating">
            {BtnPrefixComponent ? <BtnPrefixComponent /> : null}
            {!!(onSkip && skipButtonText) && (<Button transparent onPress={onSkip} title={skipButtonText}/>)}
            {!!(secondaryButtonText && onSecondaryButtonPress) && (<Button title={secondaryButtonText} onPress={onSecondaryButtonPress} leftIcon={secondaryButtonLeftIcon} brandReversed/>)}
            <Button title={buttonText || strings.continue} onPress={handlePress} brand/>
          </ButtonGroup>
        </SuccessView>
      </View>);
});
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
